module.exports = __webpack_public_path__ + "img/methoden_240.93dee39d.png";